import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Footer from "./Footer";
import '../App.css';

const Notar = () => {
  return (
    <div className="App">

      <main>

      <ResponsiveAppBar />

        <Container maxWidth="lg" className="container serviceContainer">
          <Typography variant='h2' className='sectionTitle'>Unser Team</Typography>

          <Box className="teamGrid">

            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Astrid Becker</b></Typography>
                  <Typography variant='body1'>Empfang</Typography>
                </Box>
            </Box>
            
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Diana Ernst </b></Typography>
                  <Typography variant='body1'>Notarfachassistentin</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Natalia Gusdek</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Romina Harder</b></Typography>
                  <Typography variant='body1'>Auszubildende</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Alexandra König </b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Stefan Palenberg</b></Typography>
                  <Typography variant='body1'>Notarfachassistent</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Suzan Siegberg</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Vita Sorychta-Mehrabani</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Sabrina Tönges</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Melanie Vilshöver</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>
            <Box className="teamItem">
                <Box className="teamImgWrapper none">
                  <img src='Harbecke-Profil.webp' className='teamImg none' />
                </Box>                
                <Box className="teamItemTextWrapper">
                  <Typography variant='body1'><b>Anika Wiwiorra</b></Typography>
                  <Typography variant='body1'>Notarfachangestellte</Typography>
                </Box>
            </Box>


          </Box>

        </Container>

      </main >
      <Footer />
    </div >
  );
}

export default Notar;